// global parameters
const Configuration = {
  api_version: "1.0.2", // TODO: extract version from package.json
  client_version: "1.0.0",
  // #33372, use this when params not loaded.
  DEFAULT_SYSOPTION: "FI",
};

export default Configuration;
